import { AlertService } from './../../../providers/alert.service';
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs/Observable";

import { CurrLotteryModel } from "../../../models/betting.model";
import { BettingService } from "../../../services/betting.service";
import { AuthService } from '../../../providers/auth.service';
import { IndexDBService } from "./../../../providers/indexdb.service";
import { TableLotteryModel } from "./../../../models/indexdb.model";
import { AppConfig } from "./../../app.config";

@Injectable()
export class LotteryResolver implements Resolve<CurrLotteryModel> {
    providers: [IndexDBService];
    storeName: string = "LotteryModelInfo";
    constructor(
        private bettingService: BettingService,
        private alert: AlertService,
        private auth: AuthService,
        private router: Router,
        private indexDBService: IndexDBService,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.alert.Loading();
        let lotteryCode = route.params["lotteryCode"];
        return this.indexDBService.selectByKey(this.storeName, lotteryCode).catch(() => {

        }).then((res) => {
            if (!res) {
                return this.bettingService.getLottery(route.params["lotteryCode"]).catch((error) => {
                    this.alert.CloseLoading();
                    if (error.status == 401) {
                        this.alert.errorAlert('尊敬的客户，由于您长时间未操作，为了您的资金安全，系统已将您账号自动下线。', '提示', false, () => {
                            this.auth.logout();
                            this.router.navigateByUrl('login');
                        }, () => {
                            this.auth.logout();
                            this.router.navigateByUrl('login')
                        });
                    }
                    else {
                        this.alert.errorAlert("获取期号异常，请尝试刷新页面");
                    }
                }).then((result) => {
                    let obj = result;
                    let T = setInterval(() => {
                        if (AppConfig.timing > 0) {
                            clearInterval(T);
                            obj.timer = AppConfig.timing;
                            let tabLottery = new TableLotteryModel(lotteryCode, JSON.stringify(obj));
                            if (result) {
                                // console.log(AppConfig.timing, '插入数据------------', obj);
                                this.indexDBService.insert(this.storeName, tabLottery, lotteryCode);
                            }
                        }
                    }, 50);


                    return result;
                })
            } else {
                this.alert.CloseLoading();
                if (res.lotteryDetail && JSON.parse(res.lotteryDetail).hasOwnProperty("timer") && JSON.parse(res.lotteryDetail).timer == AppConfig.timing) {
                    return JSON.parse(res.lotteryDetail);
                } else {
                    if (JSON.parse(res.lotteryDetail).timer != AppConfig.timing) {
                        // console.log('本地获取时间戳：', JSON.parse(res.lotteryDetail).timer, '后台获取时间戳：', AppConfig.timing);
                        this.indexDBService.clear(this.storeName);
                    }
                    return this.bettingService.getLottery(route.params["lotteryCode"]).catch((error) => {
                        this.alert.CloseLoading();
                        if (error.status == 401) {
                            this.alert.errorAlert('尊敬的客户，由于您长时间未操作，为了您的资金安全，系统已将您账号自动下线。', '提示', false, () => {
                                this.auth.logout();
                                this.router.navigateByUrl('login');
                            }, () => {
                                this.auth.logout();
                                this.router.navigateByUrl('login')
                            });
                        }
                        else {
                            this.alert.errorAlert("获取期号异常，请尝试刷新页面");
                        }
                    }).then((result) => {
                        let obj = result;
                        let T = setInterval(() => {
                            if (AppConfig.timing > 0) {
                                clearInterval(T);
                                obj.timer = AppConfig.timing;
                                let tabLottery = new TableLotteryModel(lotteryCode, JSON.stringify(obj));
                                if (result) {
                                    // console.log(AppConfig.timing, '插入数据------------', obj);
                                    this.indexDBService.insert(this.storeName, tabLottery, lotteryCode);
                                }
                            }
                        }, 50);
                        return result;
                    })
                }

            }
        })
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/pages/lottery/lottery.resolver.ts